import React from 'react';

import SelectTitle from "../../../../../components/radioGroup/SelectTitle";
import RadioGroup from "../../../../../components/radioGroup/RadioGroup";
import FormControlLabel from "../../../../../components/radioGroup/FormControlLabel";
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";
import {CarrierIconsList} from "../../../../../utils/carrierIconsList";

// no hand-picked icon: the API resolves it from the delivery mode and the carrier
const AUTOMATIC_ICON = '';

function CarrierIconField(props) {
    const {values, setFieldValue, setFieldTouched} = useFormikContext();

    return (
        <>
            <SelectTitle titleTranslationKey={'shippingMethods.form.field.carrierIcon.label'} />
            <RadioGroup
                alignListWithButton
                placeholder={<FormattedMessage id={"shippingMethods.form.field.carrierIcon.automatic"}/>}
                selectedValueLabel={values.carrierIcon ?
                    <FormattedMessage id={`wms.carrier.name.${values.carrierIcon}`}/> : ""}
                name={'carrierIcon'}
                value={values.carrierIcon ?? AUTOMATIC_ICON}
                onClickAway={() => setFieldTouched('carrierIcon')}
                onChange={(event, value) => {
                    setFieldValue('carrierIcon', value === AUTOMATIC_ICON ? null : value)
                }}
            >
                <FormControlLabel
                    value={AUTOMATIC_ICON}
                    label={<FormattedMessage id={'shippingMethods.form.field.carrierIcon.automatic'}/>}
                />
                {CarrierIconsList.toArray().map((carrier, index) => {
                    return (
                        <FormControlLabel
                            key={index}
                            value={carrier}
                            label={<FormattedMessage id={`wms.carrier.name.${carrier}`}/>}
                        />
                    )
                })}
            </RadioGroup>
        </>
    );
}

export default CarrierIconField;
